import { axiosInstance as axios } from "services";

export const unblockCompany = async (companyId) => {
  const { data } = await axios.post(`/admin/subscription/company/${companyId}/unblock`);
  if (!data.success) throw new Error(data.error?.message || "Failed to unblock company");
  return data;
};

